import React from 'react';
import { Navigate, Outlet, NavLink, useLocation } from 'react-router-dom';
import { useFieldAuth } from '../../contexts/FieldAuthContext';
import './FieldLayout.css';

const FieldLayout: React.FC = () => {
  const { isAuthenticated, loading, logout } = useFieldAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="field-layout-loading">
        <div className="field-spinner-large"></div>
        <p>Uzman Destek Saha Paneli Yükleniyor...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/field/login" replace />;
  }

  return (
    <div className="field-layout">
      {!navigator.onLine && (
        <div className="field-offline-banner">
          ⚠️ İnternet bağlantısı kesildi. Çevrimdışı moddasınız.
        </div>
      )}
      <main className="field-main">
        <Outlet />
      </main>
    </div>
  );
};

export default FieldLayout;
